var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMentorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-label": "People",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00C6EA",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 24,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 52c1.2-10 7.2-15 15-15s13.8 5 15 15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 24,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 37c7.4.6 13.4 5.6 15 15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMentorship);
export default __webpack_public_path__ + "static/media/icon-mentorship.6e1ce6755a730bc7b16f3f89c7700f6a.svg";
export { ForwardRef as ReactComponent };